<template>
	<div>
		<section class="otherNeighborhoodsSection sectionPadBottom" v-if="$store.state.similarNeighborhoods.length > 0">
			<div class="container-fluid otherNeighborhoods">
				<h2 class="mainTitle">
					מעבר אל שכונות ב{{ $store.state.settlementName }}
				</h2>

				<div class="scroll-container">
					<a href="#" class="nav-arrow left" @click.prevent="scrollNavBar(-200)"></a>
					<div class="buttons-container1">
						<button v-for="(neighborhood, index) in $store.state.similarNeighborhoods" :key="index"
						@click="goToNeighborhood(neighborhood.id)" class="nav-button1">{{ neighborhood.title  }}</button>
					</div>
					<a href="#" class="nav-arrow right"  @click.prevent="scrollNavBar(200)"></a>
				</div>
				<div  class="neighborhoodsCount">
					<span class="text">
						סה"כ {{ $store.state.similarNeighborhoods.length }} שכונות</span
					>
				</div>
			</div>
		</section>
	</div>
</template>

<script>


export default {
	name: "NeighScroller",
	props: {
		msg: String,
	},
	data() {
		return {
			similarNeighborhoods: [],
			centerIndex: -1,
			scrollPosition: 0,
			contentWidth: 0,
			summaryTypeName: "",
		};
	},
	computed: {
		routeName() {
			return this.$route.name;
		},
		nearByObjects() {
			var objects = this.$store.state.nearByMenu;

			return objects;
		},
	},
	methods: {
		scrollNavBar(amount) {
			const container = document.querySelector('.buttons-container1');
            container.scrollLeft += amount;
			
        },
		handleScroll() {
			//
			this.scrollPosition = this.$refs.containerRefNeigh.scrollLeft;
			this.contentWidth =
				this.$refs.containerRefNeigh.scrollWidth -
				this.$refs.containerRefNeigh.clientWidth;
		},
		animateScroll(targetPosition) {
			const start = this.$refs.containerRefNeigh.scrollLeft;
			const distance = targetPosition - start;
			const duration = 300; // Animation duration in milliseconds
			const startTime = performance.now();

			const animate = (currentTime) => {
				const elapsedTime = currentTime - startTime;
				const easeValue = easeOutQuad(elapsedTime, start, distance, duration);
				this.$refs.containerRefNeigh.scrollLeft = easeValue;

				if (elapsedTime < duration) {
					requestAnimationFrame(animate);
				}
			};

			// Easing function (you can use different easing functions as needed)
			const easeOutQuad = (t, b, c, d) => {
				t /= d;
				return -c * t * (t - 2) + b;
			};

			requestAnimationFrame(animate);
		},
		setCenterItem(index) {
			this.centerIndex = index;
			this.$nextTick(this.scrollToCenter);
		},
		scrollToCenter() {
			const container = this.$refs.containerRefNeigh;
			const item = container.querySelector(".item.center-item");

			if (item) {
				//offsetLeft

				const scrollPosition =
					item.offsetLeft - (container.offsetWidth - item.offsetWidth);

				// set animation for scroll event
				this.animateScroll(scrollPosition);
				//container.scrollLeft = scrollPosition;
			}
		},
		scrollLeft() {
			if (this.centerIndex > 0) {
				this.setCenterItem(this.centerIndex - 1);
			}
		},
		scrollRight() {
			if (
				this.centerIndex <
				this.$store.state.similarNeighborhoods.length - 1
			) {
				this.setCenterItem(this.centerIndex + 1);
			}
		},
		goToNeighborhood(neighborhoodId) {
			// get the base url domain...
			const baseUrl = window.location.protocol + "//" + window.location.host;
			///?view=neighborhood&id=:neighborhoodId/buy/deals
			//const newPath = baseUrl + `/neighborhood/${neighborhoodId}/buy/deals`;
			const newPath =
				baseUrl + `/?view=neighborhood&id=${neighborhoodId}&page=deals`;
			window.location.href = newPath;
		},
	},
	mounted() {
		//this.setCenterItem(0);


		
		const the_container = document.querySelector('.buttons-container1');
		if (!the_container) return;
        let isDown = false;
        let startX;
        let scrollLeft;

        the_container.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX - the_container.offsetLeft;
            scrollLeft = the_container.scrollLeft;
        });

        the_container.addEventListener('mouseleave', () => {
            isDown = false;
        });

        the_container.addEventListener('mouseup', () => {
            isDown = false;
        });

        the_container.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - the_container.offsetLeft;
            const walk = (x - startX) * 3;
            the_container.scrollLeft = scrollLeft - walk;
        });

        the_container.addEventListener('wheel', (e) => {
            e.preventDefault();
            the_container.scrollLeft += e.deltaY * 3;
        });







	},
};
</script>



<style scoped>

body {
	font-family: Arial, sans-serif;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	margin: 0;
	background-color: #f0f0f0;
}
.scroll-container {
	margin-bottom: 20px;
	position: relative;
	max-width: 900px;
	width: 100%;
	overflow: hidden;
	background-color: white;
	border-radius: 20px;
	padding: 5px 40px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}
.buttons-container1 {
	margin-left: 15px;
	margin-right: 15px;
	display: flex;
	overflow-x: auto;
	scroll-behavior: auto;
	scrollbar-width: none;
	-ms-overflow-style: none;
	scroll-snap-type: x proximity;
	padding: 10px;
}
.buttons-container1::-webkit-scrollbar {
	display: none;
}
.nav-button1 {
	font-weight: bold;
	background-color: white;
	border: 1px solid #e0e0e0;
	border-radius: 20px;
	padding: 10px 20px;
	margin: 0 5px;
	font-size: 14px;
	color: #333;
	cursor: pointer;
	white-space: nowrap;
	flex-shrink: 0;
	scroll-snap-align: start;
}
.scroll-container::before,
.scroll-container::after {
	content: '';
	position: absolute;
	top: 0;
	bottom: 0;
	width: 40px;
	background: linear-gradient(to right, white, transparent);
	z-index: 1;
	pointer-events: none;
}
.scroll-container::before {
	left: 0;
	background: linear-gradient(to left, transparent, white);
}
.scroll-container::after {
	right: 0;
	background: linear-gradient(to right, transparent, white);
}
.nav-arrow {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	width: 40px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.8);
	border: none;
	font-size: 20px;
	color: #333;
	cursor: pointer;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	border-radius: 50%;
}
.nav-arrow:hover {
	background-color: rgba(240, 240, 240, 0.9);
}
.nav-arrow.left {
	left: 5px;
}
.nav-arrow.right {
	right: 5px;
}
.nav-arrow.left::before {
	content: "\003E";
}
.nav-arrow.right::before {
	content: "\003C";
}

/* Media query for mobile screens */
@media (max-width: 768px) {
	/* Remove padding */
	.scroll-container {
		padding: 0;
	}
	
	/* Hide .nav-arrow.left and .nav-arrow.right */
	.nav-arrow.left,
	.nav-arrow.right {
		display: none;
	}

	.sectionPadBottom{
		padding-top: 30px;
		padding-bottom: 30px;
	}
	
}
</style>
